<ng-container *ngIf="infos$ | async as infos; else loadingOrError">
  <up-feature-card-default header="Informações" [editable]="true" [disabledEdit]="!infos.active" [newBrand]="true" #contratuais>
      <div class="static">
          <app-dados-colaborador [infos]="infos"></app-dados-colaborador>
      </div>
      <div class="editing">
          <app-form-colaborador (reload)="editCallback()" [colaboradorRef]="contratuais" [infos]="infos"></app-form-colaborador>
      </div>
  </up-feature-card-default>
  <up-feature-card-default header="Informações Adicionais" [editable]="true" [newBrand]="true" [disabledEdit]="!infos.active" #infosAdicionais>
      <div class="static">
          <app-infos-add-colab [infos]="infos"></app-infos-add-colab>
      </div>
      <div class="editing">
        <app-form-infos-add-colab  (reload)="editCallback()" [colaboradorRef]="infosAdicionais" [infos]="infos"></app-form-infos-add-colab>
    </div>
  </up-feature-card-default>
  <up-feature-card-default header="Contato" [editable]="true" [newBrand]="true" [disabledEdit]="!infos.active" #pessoal>
      <div class="static">
          <app-infos-contato-colab [infos]="infos"></app-infos-contato-colab>
      </div>
      <div class="editing">
          <app-form-contato-colab (reload)="editCallback()" [colaboradorRef]="pessoal" [infos]="infos"></app-form-contato-colab>
      </div>
  </up-feature-card-default>
</ng-container>

<ng-template #loadingOrError>
  <div *ngIf="error$ | async as error; else loading" class="profile-loading error-loading">
      <div *ngIf="error.status === 403">
          <img src="assets/images/core/ico-erro.svg" alt="" class="fadeInDown">
          <div class="fadeInUp">
              <p>Você não tem permissão para visualizar esta página.</p>
              <small>403 - Acesso Negado</small>
          </div>
      </div>
  </div>
  <ng-template #loading>
    <div class="profile-loading">
        <div class="spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
        </div>
    </div>
  </ng-template>
</ng-template>
